import * as React from "react";

function SvgCrisp(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 718.6 619"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <linearGradient
        id="Crisp_svg__a"
        gradientUnits="userSpaceOnUse"
        x1={460.283}
        y1={463.988}
        x2={460.283}
        y2={464.95}
        gradientTransform="matrix(682.7454 2.9791 2.4175 -554.0426 -315024.531 256271.578)"
      >
        <stop offset={0} stopColor="#137ece" />
        <stop offset={1} stopColor="#288bd5" />
      </linearGradient>
      <path
        d="M280.1 470.1l108 114.6 84.2-135.8 223.3-24.6-36-392.4-645.4 71.2 36 392.4 229.9-25.4z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="url(#Crisp_svg__a)"
      />
    </svg>
  );
}

export default React.forwardRef(SvgCrisp);
